import dayjs, { ManipulateType } from 'dayjs';

export type DateOperation =
  | {
      op: 'add';
      value: number;
      type: ManipulateType;
    }
  | {
      op: 'subtract';
      value: number;
      type: ManipulateType;
    };

export const calculate = (date: DateOperation) => {
  switch (date.op) {
    case 'add':
      return dayjs().add(date.value, date.type);
    case 'subtract':
      return dayjs().subtract(date.value, date.type);
  }
};
